// extracted by mini-css-extract-plugin
export default {"emptyListWrapper":"EmptyListPlaceholder_emptyListWrapper__lsk7r","emptyListBox":"EmptyListPlaceholder_emptyListBox__DGRBl"};